<template>
  <div class="content Tabs">

     <b-tabs card>

          <b-tab :title="lang.tab_ImportBom"  :title-link-class="textColors" :title-item-class="textColors" active >
            <b-container class="bv-example-row">

              <b-form class="file-form">
                <p>{{lang.label_file}}:</p>
                <br>
                <b-row>
                  <b-col cols="1"  class="label-type">{{lang.label_Delimiter}}:</b-col>
                  <b-col cols="2">
                    
                    <b-form-group id="input-group-Delimiter" >
                      <b-form-select size="sm" class="select-delimiter" v-model="delimiter" :options="delimiterOptions"></b-form-select>
                      
                    </b-form-group>
                  </b-col>
                  <b-col cols="7">
                    <b-form-file
                      id="file-import"
                      v-model="file"
                      :state="fileState"
                      :placeholder= lang.placeholder_file
                      drop-placeholder= lang.placeholder_file
                      class="import-file"
                      accept=".csv, .rpt"
                      size="sm"
                      

                    ></b-form-file><br>
                    <label v-show="!extension" class="file-import-invalid">
                        {{ lang.label_file_invalid }}
                      </label>
                  </b-col>
                  <b-col cols="2">
                    <!-- <b-button @click="uploadFile" class="upload-form-button" size="sm" :variant="variant">{{lang.button_Upload}}</b-button> -->

                  </b-col>
                </b-row>
                
                  
              </b-form>
              <hr>
              
              <span  v-if="isProps">
                
                {{lang.textarea_label_Name}}:
                <b-form-input  v-if="variantsOptions.length == 0"
                  id="inputNameBom"
                  class="inputNameBom"
                  v-model="name"
                  :placeholder="lang.placeholder_Name"
                  type= "text"
                ></b-form-input>
                <br>
                <b-form-select v-if="variantsOptions.length > 0" size="sm" class="select-variant" v-model="name" :options="variantsOptions"></b-form-select>
                
                {{ lang.textarea_label_BomNumber }}
                <b-form-input  v-if="variantsOptions.length == 0"
                  id="inputNumberBom"
                  class="inputNumberBom"
                  v-model="bomNumber"
                  :placeholder="lang.placeholder_BomNumber"
                  type= "text"
                ></b-form-input>
                <br>
                <b-form-select v-if="variantsOptions.length > 0" size="sm" class="select-variant" v-model="bomNumber" :options="variantsOptions"></b-form-select>

                {{lang.textarea_label_Description}}:
                <b-form-textarea
                  id="textareaDescriptionBom"
                  class="textareaDescriptionBom"
                  v-model="description"
                  :placeholder="lang.textarea_placeholder"
                  rows="3"
                  max-rows="6"
                  ></b-form-textarea>
                <hr>
                <p>{{lang.infotext_1}}:</p>
                <MappingBomTableComponent :lang="lang.TableMapping"></MappingBomTableComponent>
              </span>
            </b-container>
          </b-tab>


        </b-tabs>



  </div>

</template>
<script>
import { mapGetters } from 'vuex'




import MappingBomTableComponent from '@/components/shared/MappingBomTableComponent'

export default {
  name: "Content",
  components: {
    
    MappingBomTableComponent

  },
  props:{
    lang: Object,

  },
  data () {
    return {
      file: null,
      isProps: false,
      name: "",
      description: "",
      bomNumber: "",
      delimiterOptions: [
        { value: ",", text: ',' },
        { value: ';', text: ';' },
        { value: 'tab', text: '{Tab}' },

      ],
      delimiter: ",",
      variantsOptions: [],
      extension: false
    }
  },
  computed: {
    ...mapGetters({
      

    }),
    fileState() {
      
      this.extension = false;
      if (this.file != null) {
        
        let temp = this.file.name.split(".");
        if (temp[temp.length - 1].toLowerCase() == 'csv' || temp[temp.length - 1].toLowerCase() == 'rpt' ) {
          this.extension = true;
        }
      }
      
      return Boolean(this.file) && this.extension;
    },
    lastRevisionHistory() {
      if (this.$store.getters.revisionHistory == null) {
        return
      }
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    revisionId() {
      if (this.lastRevisionHistory == undefined) {
        return
      }
      return this.lastRevisionHistory.id;
        
    },
    objDescription(){
      
      return this.description;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    },
    
  },
  created () {
    this.getVariants();

  },

  updated() {
    

    const obj = {
      description: this.description,
      name: this.name,
      bomNumber: this.bomNumber
    }
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_setBomDescription", obj)
  },
  watch: {
    file: function (newVal) {

      if (this.file != null) {

        let temp = newVal.name.split(".");
        if (temp[temp.length - 1].toLowerCase() == 'csv' || temp[temp.length - 1].toLowerCase() == 'rpt') {
          this.uploadFile();
        }
      }
      
      
    },
    delimiter: function (newVal){
      
      this.$parent.$parent.$parent.setSeparator(newVal);
      if (this.file != null) {
        this.uploadFile();
      }
    }
  },
  methods:{
    getVariants(){

      this.variantsOptions = [];

      const variants = this.$store.getters.variants;

      for (let i = 0, lei = variants.length; i < lei; i++){

    

        let obj = {
          value: variants[i].name, 
          text: variants[i].name,
          
        }
        this.variantsOptions.push(obj);
      }

      if (this.$store.getters.isBom == false) {
        this.name = "BOM Core";
      }
      // if (this.variantsOptions.length == 0){
      //   let obj = {
      //     value: "No variant", 
      //     text: "No variant",
          
      //   }
      //   this.variantsOptions.push(obj);
      // }

      
    },
    uploadFile(){
      this.$store.dispatch("showLoader", { visible: true, text: "load" });

      let _vue = this;

      let obj = {
        file:{
          file: this.file,
        },
        
        revisionId: this.revisionId,
        separator: this.delimiter
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_importBom", obj)
      .then(function(result) {
         _vue.$store.dispatch("showLoader", { visible: false });
        console.log(result.data)
        if (result.status == "OK") {
          if (result.data.Data != null) {

           

            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setPreviewParts", result.data.Data);
            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setImportedFileId", result.data.fileId);
            _vue.isProps = true;

            const obj = {
              text: _vue.lang.alert_success_importBOM,
              time: 10,
              type: "success"
            }
            _vue.$store.dispatch("displayFooterAlert", obj);
          } else {
            const obj = {
              text: _vue.lang.alert_error_importBOM + ".",
              time: 15,
              type: "danger"
            }


            _vue.$store.dispatch("displayFooterAlert", obj);
          }
        } else {
          const obj = {
            text: _vue.lang.alert_error_importBOM + ": " + result.message,
            time: 15,
            type: "danger"
          }


          _vue.$store.dispatch("displayFooterAlert", obj);
        }
        



      })
      .catch((reason) => {

          console.log("Error:", reason)

          _vue.$store.dispatch("showLoader", { visible: false });
      })

    },


  },
  
}
</script>

<style lang="scss">
  @import "@/scss/_custom.scss";
.Tabs{
    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }

    .file-form{
      width: 80%;
    }

    .upload-form-button{

      margin-left: 10px;
      margin-top: 2px;
    }
    
    .container{
      margin-left: 10px !important;
    }
    .select-variant{
      width: 300px;
    }
    .inputNameBom{
      width: 400px;
    }
    .inputNumberBom{
      width: 400px;
    }
    .textareaDescriptionBom{
      margin-top: 2px;
      width: 800px;
    }
    .file-import-invalid{
      color: $redfont;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectImportBom/Middle/Content/Content.vue